import { cn } from '@/lib/utils';
import { Skeleton } from '@/components/ui/Skeleton.tsx';
import { Card } from '@/components/ui/Card.tsx';
import { changeHistoryGridClass } from './changeHistoryGrid';

interface ChangeHistoryTableSkeletonProps
  extends React.HTMLAttributes<HTMLDivElement> {
  /** Ile wierszy historii odwzorować. */
  rowCount?: number;
}

/** Szkielet tabeli „Historia paczek" — te same kolumny co `ChangeHistoryTable`. */
const ChangeHistoryTableSkeleton = ({
  rowCount = 3,
  className,
  ...props
}: ChangeHistoryTableSkeletonProps) => (
  <Card className={cn('overflow-hidden', className)} {...props}>
    <div className="flex items-baseline gap-2.5 px-7 pb-3.5 pt-5">
      <Skeleton className="h-3 w-32" />
      <Skeleton className="h-3 w-48" />
    </div>

    <div
      className={cn(
        changeHistoryGridClass,
        'border-b border-neutral-100 pb-2.5',
      )}
    >
      {['paczka', 'zakres', 'wprowadzona', 'wplyw'].map((column) => (
        <Skeleton key={column} className="h-3 w-24" />
      ))}
    </div>

    {Array.from({ length: rowCount }).map((_, index) => (
      <div
        key={index}
        className={cn(
          changeHistoryGridClass,
          'items-baseline border-b border-dashed border-neutral-100 py-3.5',
        )}
      >
        <div className="flex flex-col gap-1.5">
          <Skeleton className="h-4 w-28" />
          <Skeleton className="h-3 w-20" />
        </div>
        <Skeleton className="h-4 w-52" />
        <div className="flex flex-col gap-1.5">
          <Skeleton className="h-4 w-32" />
          <Skeleton className="h-3 w-24" />
        </div>
        <Skeleton className="h-4 w-24 justify-self-end" />
      </div>
    ))}

    <div className="px-7 pb-[18px] pt-3.5">
      <Skeleton className="h-3.5 w-full max-w-[520px]" />
    </div>
  </Card>
);

export default ChangeHistoryTableSkeleton;
